import { useTranslation } from 'react-i18next'
import { Controller, useForm } from 'react-hook-form'
import { css } from '@emotion/react'
import { CommonFilters, StateCheckbox } from '@components/inputs'
import { ManagerTypeType, UserActivityState } from '@definitions'
import { ManagerType } from '@pages/types'
import { GetManagersPayloadType } from '@api'
import {
  Drawer,
  Button,
  FormItem,
  SelectOption,
  Text,
  SelectInput,
  Title,
  Form,
} from 'common-components'

type FiltersManagersPropsType = {
  data: ManagerType[]
  visible: boolean
  onClose: () => void
  onParamsChange: (params: GetManagersPayloadType) => void
}

const FiltersManagers = ({ visible, onClose, onParamsChange }: FiltersManagersPropsType) => {
  const { t } = useTranslation()
  const { handleSubmit, control } = useForm<GetManagersPayloadType>()

  const onSubmit = (data: GetManagersPayloadType) => {
    onParamsChange && onParamsChange(data)
    onClose()
    return data
  }

  return (
    <Drawer
      title={
        <div
          css={css`
            display: flex;
            flex-direction: column;
          `}
        >
          <Title preset='tablePageTitle'>{t('common.filter')}</Title>
          <Text>{t('common.apply')}</Text>
        </div>
      }
      placement='right'
      closable={true}
      onClose={onClose}
      closeIcon={false}
      open={visible}
    >
      <Form
        onReset={() => {
          control._reset()
          onSubmit({ model: {} })
        }}
        onFinish={handleSubmit(onSubmit)}
        css={drawerContentStyle}
      >
        <CommonFilters control={control} />

        <Controller
          name={'model.type'}
          control={control}
          render={({ field }) => (
            <FormItem label='Role'>
              <SelectInput
                mode={'tags'}
                value={field.value}
                onChange={field.onChange}
                css={fullWidthStyle}
              >
                {Object.entries(ManagerTypeType).map(([id, label]) => (
                  <SelectOption key={id} value={Number(id)}>
                    {label}
                  </SelectOption>
                ))}
              </SelectInput>
            </FormItem>
          )}
        />
        <Controller
          name={'model.activity'}
          control={control}
          render={({ field }) => (
            <FormItem label={t('common.state')}>
              <StateCheckbox
                values={UserActivityState}
                labelTxKey={'userActivity'}
                preset={'skill'}
                inputProps={{
                  onChange: field.onChange,
                  value: field.value,
                }}
              />
            </FormItem>
          )}
        />

        <div css={filterButtonsStyle}>
          <Button type='primary' htmlType='submit'>
            Apply
          </Button>
          <Button htmlType='reset'>Cancel</Button>
        </div>
      </Form>
    </Drawer>
  )
}

const drawerContentStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const fullWidthStyle = css`
  width: 100%;
`

const filterButtonsStyle = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`

export default FiltersManagers
